<template>
  <div class="alerts-container">
    <el-dialog center title :visible.sync="opened">
      <span>
        <card>
          <h4 class="card-title text-center">Alertas IQ Option</h4>

          <hr />
          <div class="card-body">
            <h5>
              Adicione um alerta para o par {{ assetName }} em
              {{ timeScale.computed }}
            </h5>
            <div class="col-md-12">
              <div>Adicione um padrão</div>
              <div class="slide">
                <div>
                  <button class="btn btn-green btn-sm" @click="addColorToArray('green')">Verde</button>
                  <button class="btn btn-red btn-sm" @click="addColorToArray('red')">Vermelho</button>
                  <button class="btn btn-grey btn-sm" @click="addColorToArray('doji')">Doji</button>
                  <button class="btn btn-neutral btn-fill btn-sm" @click="cleanColors()">Limpar</button>
                </div>
              </div>
            </div>

            <hr />
            <div class="col-md-12">
              <ul id="candles" class="row card-body col-lg-12 col-md-12 col-sm-12">
                <li v-for="(color, index) in observer" :key="index">
                  <button type="button" :class="'btn btn-md btn-' + color" />
                </li>
              </ul>
            </div>
            <span>
              <button
                type="button"
                class="btn btn-round btn-sm btn-fill"
                :class="theme === 'black' ? 'btn-azure2' : 'btn-primary'"
                @click="sendAlert"
              >Salvar padrao</button>
            </span>
          </div>
        </card>
      </span>
    </el-dialog>

    <div class="button-toggle-div">
      <button
        class="btn btn-round btn-sm btn-fill"
        :class="theme === 'black' ? 'btn-azure2' : 'btn-primary'"
        @click="this.toggleSlide"
      >Alertas</button>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
export default {
  name: "alerts-iq",
  props: {
    asset: Number,
    assetName: String,
    timeScale: { raw: Number, computed: String }
  },

  data() {
    return {
      opened: false,
      observer: [],
      socket: null
    };
  },
  beforeMount() {
    // connect to  https://websocket.top-trader.org
    this.socket = io("http://localhost:1994/alerts");
  },
  mounted() {
    this.socket.on("connect", () => {});

    this.socket.on("alerts", value => console.log(value));

    this.socket.on("error", err => {
      // console.error(err);
      this.socketConnected = false;
      // this.socket.close();
    });

    this.socket.on("disconnecting", reason => {
      // console.log(reason);
      // ...
    });

    this.socket.on("disconnect", () => {
      this.socket.close();
    });
  },
  methods: {
    toggleSlide() {
      this.opened = !this.opened;
    },
    addColorToArray(color) {
      this.observer.push(color);
    },
    cleanColors() {
      this.observer = [];
    },
    sendAlert() {
      if (this.socket.readyState !== this.socket.OPEN) {
        return null;
      }

      this.socket.emit("alerts", {
        code: this.$props.asset,
        size: this.$props.timeScale.raw,
        observer: this.observer
      });
      this.opened = false;
    }
  },
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>

<style lang="scss">
.alerts-container {
  display: inline-block;
}

#candles {
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AlertsIQ.vue